export default __webpack_public_path__ + "static/media/team64.266f9b61.JPG";